import React, { useState } from "react"

import { OutlinedInput, InputAdornment, IconButton } from "@material-ui/core";

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const CustomInputField = (props) => {
    const { classes, element, dataObj, onChange, styles, selectedStep, inputClasses } = props
    const [isFocused, setIsFocused] = useState(false);
    const getValueFromPath = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    const rawValue = getValueFromPath(dataObj, element.value) || dataObj[element.name];

    let displayValue = rawValue || "";

    // Only apply the £/%/amount display formatting while NOT focused. Formatting on every
    // keystroke (re-adding symbols/decimals) fights typing and makes deleting look broken,
    // since the freshly-typed text gets immediately replaced by the reformatted string.
    if (!isFocused && element.showPoundIcon) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        if (displayValue !== "") {
            const numericVal = parseFloat(displayValue);

            displayValue = !isNaN(numericVal)
                ? `£${numericVal.toLocaleString("en-GB", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                })}`
                : displayValue;
        }
    }
    else if (!isFocused && element.showPercentageIcon) {
        if (typeof displayValue === "string") {
            displayValue = displayValue.replace(/%/g, "").trim();
        }

        if (displayValue !== "") {
            let numericVal = parseFloat(displayValue);

            if (!isNaN(numericVal)) {
                // if value looks like a fraction (0–1), convert to %
                if (numericVal <= 1) {
                    numericVal = numericVal * 100;
                }

                displayValue = `${numericVal.toLocaleString("en-GB", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                })}%`;
            }
        }
    }

    else if (!isFocused && element.isAmountField) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        if (displayValue !== "") {
            const numericVal = parseFloat(displayValue);

            displayValue = !isNaN(numericVal)
                ? `${numericVal.toLocaleString("en-GB", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                })}`
                : displayValue;
        }
    }
    else if (element.type === "date" && displayValue !== "" && displayValue != null) {
        if (displayValue instanceof Date && !isNaN(displayValue.getTime())) {
            displayValue = displayValue.toISOString().slice(0, 10);
        } else if (typeof displayValue === "string") {
            const trimmed = displayValue.trim();
            const isoDate = trimmed.match(/^(\d{4}-\d{2}-\d{2})(?:[\sT].*)?$/);
            if (isoDate) {
                displayValue = isoDate[1];
            }
        }
    }

    const handleViewClick = (viewUrl, displayValue, isTabOpen) => {
        if(isTabOpen && props?.setActiveTabMain) {
            props.setActiveTabMain("spendDetails");
        }
        if (viewUrl && displayValue) {
            window.open(`${window.location.origin}/${props?.match?.params?.appid}/page/${element.viewUrl}/${displayValue}`, '_blank');
        }
    };

    return (
        <OutlinedInput
            id={`${element.name}`}
            variant="outlined"
            style={{
                width: "100%",
                height: "32px",
                padding: '5px 8px 6px 8px'
            }}
            classes={{
                root: inputClasses?.smallOutlinedInput,
                notchedOutline: inputClasses?.smallNotchedOutline,
            }}
            required={element.required}
            key={element.value || element.name}
            name={element.value || element.name}
            disabled={element.readOnly}
            onPaste={(e) => {
                if (element.type === 'date' && !element.readOnly) {
                    e.preventDefault();
                }
            }}
            onKeyDown={(e) => {
                if (element.type === 'date' && !element.readOnly) {
                    e.preventDefault();
                }
            }}
            type={element.type}
            value={displayValue}
            title={displayValue}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={(e) => {
                onChange((element.value || element.name), e.target.value, element.type);
            }}
            endAdornment={
                element?.isViewEnable && displayValue && displayValue !== "" ? (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => { handleViewClick(element?.viewUrl, displayValue, element?.isTabOpen) }}
                            edge="end"
                            size="small"
                            style={{ padding: '0px', minWidth: '20px', width: '20px', height: '20px' }}
                        >
                            <OpenInNewIcon fontSize="small" style={{ fontSize: '18px' }} />
                        </IconButton>
                    </InputAdornment>
                ) : null
            }
        />
    )
}

export default CustomInputField